export const TOP_LEVEL_DRAFT_KEYS = [
  "organizational",
  "invited_modes",
  "service",
  "schedule",
  "packing_list",
  "shipment",
  "invited_providers",
  "bucket_attachments",
  "other_attachments",
] as const;

const TOP_LEVEL_DRAFT_KEY_SET = new Set<string>(TOP_LEVEL_DRAFT_KEYS);

export function getTopLevelDraftKey(path?: string): string | undefined {
  if (!path) return undefined;

  const topLevel = path.split(".")[0];
  return TOP_LEVEL_DRAFT_KEY_SET.has(topLevel) ? topLevel : undefined;
}
